export function isCoxswainAthlete(athlete) {
  return athlete?.user_role === 'coxswain';
}

export function formatRoleLabel(role) {
  if (role === 'coxswain') return 'Coxswain';
  if (role === 'superadmin') return 'Superadmin';
  if (!role) return 'User';
  return role.charAt(0).toUpperCase() + role.slice(1);
}
